import styled from 'styled-components';

export const Toolbar = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(3)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  font-size: 13px;
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const VacancyRow = styled.form`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
  font-size: 14px;

  input {
    flex: 1 1 280px;
    max-width: 420px;
  }
`;

export const Summary = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(2)};
  margin-bottom: ${({ theme }) => theme.spacing(4)};
`;

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const Row = styled.div<{ $alert?: boolean }>`
  display: grid;
  grid-template-columns: 56px minmax(0, 1fr) minmax(220px, 300px);
  gap: ${({ theme }) => theme.spacing(4)};
  padding: ${({ theme }) => theme.spacing(4)};
  border-radius: ${({ theme }) => theme.radius.md};
  border: 1px solid
    ${({ theme, $alert }) => ($alert ? theme.colors.status.danger : theme.colors.border)};
  background: ${({ theme }) => theme.colors.surface};

  @media (max-width: 900px) {
    grid-template-columns: 48px minmax(0, 1fr);

    & > :last-child {
      grid-column: 1 / -1;
    }
  }
`;

export const Score = styled.div<{ $score: number }>`
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  color: #fff;
  background: ${({ theme, $score }) =>
    $score >= 70
      ? theme.colors.status.success
      : $score >= 45
        ? theme.colors.status.warning
        : theme.colors.text.secondary};
`;

export const Main = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const Headline = styled.div`
  font-weight: 600;
  font-size: 15px;
  overflow-wrap: anywhere;
`;

export const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const Small = styled.div`
  font-size: 13px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.secondary};
  overflow-wrap: anywhere;
`;

export const Contacts = styled.div`
  font-size: 13px;
  line-height: 1.6;

  a {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

export const Side = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: flex-start;
`;

export const Channels = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1.5)};
`;

export const Collapse = styled.button`
  background: none;
  border: 0;
  padding: 0;
  margin-top: ${({ theme }) => theme.spacing(4)};
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  font-size: 14px;

  &:focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadow.focus};
  }
`;

/** «Добавить пометку» у кандидата без переписки — открывает поле комментария. */
export const NoteToggle = styled.button`
  align-self: flex-start;
  background: none;
  border: 0;
  padding: 0;
  color: ${({ theme }) => theme.colors.primary};
  cursor: pointer;
  font-size: 13px;

  &:focus-visible {
    outline: none;
    box-shadow: ${({ theme }) => theme.shadow.focus};
  }
`;
